export const HYDRATION_STANDARD_SCROLL_BUFFER = 750;
export const CAROUSEL_HYDRATION_STANDARD_SCROLL_BUFFER = 1500;
export const HYDRATION_STANDARD_DELAY_TIMER = 1500;
export const PLP_PAGE = 'plppage';
export const TOOL_RENTAL = 'Tool Rental';
export const ONLINE_STORE_ID = '8119';
export const DEFAULT_LAYOUT_STYLE = 'Grid';

// BrowseAndSearch
export const PRODUCT_POD_COUNT = {
  CLIENT: 24,
  SERVER: 12,
};
export const MAX_PODS_TO_HYDRATE = {
  DESKTOP: 12,
  MOBILE: 6,
};
export const CATEGORY_CARD_POSITION_INDEX = 12;
export const CHECK_CAT_STYLE = 'catStyle=ShowProducts';
export const NTT_PREFIX = '/Ntt-';

// Recommendation requestKey
export const RECS_REQUEST_KEY = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';

export const STICKY_HEADER_HEIGHT = {
  MOBILE: 59,
  DESKTOP: 114,
};

// differentiates request calls between recs containers
// TODO: Update if necessary with new values for Major Appliance
export const requestKey = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';
